export default "__VITE_ASSET__fc06aef1__"